import { RFI_BASE_URL } from "./const";

export function rfiApiUrl() {
  if (process.env.REACT_APP_RFI_API_URL) {
    return process.env.REACT_APP_RFI_API_URL;
  }
  return RFI_BASE_URL;
}

export function getRfiSocketUrl(path) {
  const baseUrl = rfiApiUrl().replace("https://", "").replace("http://", "");
  return `wss://${baseUrl}/ws/${path}`;
}
